/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocArrowInIcon16Light } from './DocArrowInIcon16Light';
import { DocArrowInIcon16Regular } from './DocArrowInIcon16Regular';
import { DocArrowInIcon16Solid } from './DocArrowInIcon16Solid';
import { DocArrowInIcon20Light } from './DocArrowInIcon20Light';
import { DocArrowInIcon20Regular } from './DocArrowInIcon20Regular';
import { DocArrowInIcon20Solid } from './DocArrowInIcon20Solid';
import { DocArrowInIcon24Regular } from './DocArrowInIcon24Regular';
import { DocArrowInIcon24Solid } from './DocArrowInIcon24Solid';
import { DocArrowInIcon32Regular } from './DocArrowInIcon32Regular';
import { DocArrowInIcon64Regular } from './DocArrowInIcon64Regular';
var sizes = {
    16: {
        light: DocArrowInIcon16Light,
        regular: DocArrowInIcon16Regular,
        solid: DocArrowInIcon16Solid,
    },
    20: {
        light: DocArrowInIcon20Light,
        regular: DocArrowInIcon20Regular,
        solid: DocArrowInIcon20Solid,
    },
    24: {
        regular: DocArrowInIcon24Regular,
        solid: DocArrowInIcon24Solid,
    },
    32: {
        regular: DocArrowInIcon32Regular,
    },
    64: {
        regular: DocArrowInIcon64Regular,
    },
};
export var DocArrowInIcon = forwardRef('DocArrowInIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
